import React from 'react';
import * as Styled from './attendance-percentage.styles';
import {Typography, useTheme} from '@innowise-group/ui-kit';
import {useTranslation} from 'react-i18next';
import {getOfficeAttendanceTextColor, getOfficeAttendanceBgColor} from '../../../offices/utilities';

export interface AttendancePercentageProps {
  attendancePercent: number;
  attendanceType: 'office' | 'floor' | 'room';
}

const AttendancePercentage: React.FC<AttendancePercentageProps> = ({attendanceType, attendancePercent}) => {
  const {t} = useTranslation();
  const theme = useTheme();

  const titleMap = {
    office: 'pages.offices.officeDetails.officesAttendance',
    floor: 'pages.floors.averageAttendancePercent',
    room: 'pages.offices.attendance.averageAttendancePercent',
  };

  const title = t(titleMap[attendanceType]);

  const visitPercentageTextColor = getOfficeAttendanceTextColor(attendancePercent, theme);
  const visitPercentageBgColor = getOfficeAttendanceBgColor(attendancePercent, theme);

  return (
    <>
      {attendanceType === 'floor' ? (
        <>
          <Typography>{title}</Typography>
          <Styled.AttendanceFloorPercentage backgroundColor={visitPercentageBgColor} color={visitPercentageTextColor}>
            {attendancePercent}%
          </Styled.AttendanceFloorPercentage>
        </>
      ) : (
        <Styled.AttendanceOfficeTitle attendanceType={attendanceType}>
          <Typography>{title}</Typography>
          <Styled.AttendanceFloorPercentage backgroundColor={visitPercentageBgColor} color={visitPercentageTextColor}>
            {attendancePercent}%
          </Styled.AttendanceFloorPercentage>
        </Styled.AttendanceOfficeTitle>
      )}
    </>
  );
};

export default React.memo(AttendancePercentage);
